<template>
  <main class="mall_main max-w-[82.75rem] mx-auto mb-40">
    <!-- 이전 페이지로 -->
    <div class="">
      <button
        @click="goBack"
        class="w-fit p-5 flex items-center gap-2"
        aria-label="이전 페이지로 이동"
      >
        <svg
          width="24"
          height="18"
          viewBox="0 0 24 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.5 9L22.5 9M1.5 9L8.22 1.5M1.5 9L8.22 16.5"
            stroke="black"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <span class="leading-none text-sm">이전으로</span>
      </button>
    </div>

    <div class="flex gap-3 items-center mall_path_wr">
      <!-- <router-link to="/mall">HOME</router-link>
      <svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none">
        <path d="M1 1L4 4L1 7" stroke="#B7BABD" stroke-width="0.5"/>
      </svg>
      <router-link to="">하나바이블</router-link>
      <svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none">
        <path d="M1 1L4 4L1 7" stroke="#B7BABD" stroke-width="0.5"/>
      </svg>
      <router-link to="">청소년부</router-link> -->
      <!--      {{ contentDetail }}-->
    </div>

    <div class="mall_detail_container">
      <!-- 정보 -->
      <div class="mall_detail_info">
        <!-- 썸네일 -->
        <div
          class="lg:max-w-[50%] h-fit border rounded-2xl overflow-hidden flex justify-center items-center flex-shrink-0"
        >
          <img
            v-if="contentDetail.thumbnailLink"
            :src="
              'https://eduwind-api.nodeblack.net/' + contentDetail.thumbnailLink
            "
            :alt="contentDetail.title"
            width="600"
            height="400"
            class="w-[600px] h-[400px]"
          />
          <img
            v-else
            src="/assets/image/logo.svg"
            :alt="contentDetail.title"
            width="600"
            height="400"
            class="w-[600px] h-[400px] !object-contain"
          />
        </div>

        <!-- 상품설명 -->

        <div class="product_desc">
          <div
            class="w-full flex flex-col gap-y-2 pb-4 mb-4 border-b border-neutral-150"
          >
            <div class="flex gap-1">
              <p
                v-for="tag in contentDetail.tagList"
                :key="tag"
                class="product_sub_tt"
              >
                {{ tag }}
              </p>
            </div>
            <div class="product_tt lg:!text-2xl !font-semibold">
              {{ contentDetail.title }}
            </div>
          </div>

          <!-- 탭 메뉴 -->
          <dl class="tab-container mb-4 border-b border-neutral-150">
            <!-- 탭 네비게이션 -->
            <dt class="tab-navigation flex divide-x divide-neutral-100">
              <button
                @click="changeTab('product-info')"
                :class="[
                  'flex-1 h-fit px-4 text-center transition-all duration-300 text-[0.9375rem]',
                  activeTab === 'product-info'
                    ? ''
                    : 'text-neutral-500 hover:text-neutral-800',
                ]"
              >
                상품 정보
              </button>
              <button
                @click="changeTab('usage-guide')"
                :class="[
                  'flex-1 h-fit px-4 text-center transition-all duration-300 text-[0.9375rem]',
                  activeTab === 'usage-guide'
                    ? ''
                    : 'text-neutral-500 hover:text-neutral-800',
                ]"
              >
                이용 안내
              </button>
              <button
                @click="changeTab('copyright-info')"
                :class="[
                  'flex-1 h-fit px-4 text-center transition-all duration-300 text-[0.9375rem]',
                  activeTab === 'copyright-info'
                    ? ''
                    : 'text-neutral-500 hover:text-neutral-800',
                ]"
              >
                저작권 정보
              </button>
            </dt>

            <!-- 탭 콘텐츠 컨테이너 -->
            <dd
              class="tab-content-wrapper relative min-h-[200px] overflow-hidden text-sm mt-2"
            >
              <transition
                name="tab-slide"
                mode="out-in"
                enter-active-class="transition-all duration-300 ease-out"
                leave-active-class="transition-all duration-300 ease-in"
                enter-from-class="transform translate-x-4 opacity-0"
                enter-to-class="transform translate-x-0 opacity-100"
                leave-from-class="transform translate-x-0 opacity-100"
                leave-to-class="transform -translate-x-4 opacity-0"
              >
                <!-- 상품 정보 탭 -->
                <div
                  v-if="activeTab === 'product-info'"
                  key="product-info"
                  class="tab-content px-4 py-3"
                >
                  <div class="product_desc_detail mb-4">
                    <p class="font-bold">제작사</p>
                    <div>
                      {{ contentDetail.brand && contentDetail.brand.name }}
                    </div>
                  </div>

                  <!-- <p>발행일</p>
                  <div>0000-00-00</div> -->

                  <div
                    v-if="contentDetail.itemType === 'CONTENT'"
                    class="product_desc_detail mb-4"
                  >
                    <p class="font-bold">콘텐츠 유형</p>
                    <div class="mb-4">
                      {{
                        contentDetail.contentType
                          ? contentDetail.contentType
                          : "콘텐츠 유형 없음"
                      }}
                    </div>

                    <p class="font-bold">콘텐츠 분류</p>
                    <div class="mb-4">
                      {{
                        contentDetail.itemKind
                          ? contentDetail.itemKind
                          : "콘텐츠 분류 없음"
                      }}
                    </div>

                    <p class="font-bold">다운로드 기간</p>
                    <div>
                      {{
                        contentDetail.downloadPeriod > 0
                          ? contentDetail.downloadPeriod + "일"
                          : "제한 없음"
                      }}
                    </div>

                    <!-- <p>다운로드 횟수</p>
                    <div>
                      {{ contentDetail.downloadCount !== 0 ? contentDetail.downloadCount + '회' : '제한 없음' }}
                    </div> -->
                  </div>

                  <div
                    class="product_desc_detail mb-4"
                    v-if="contentDetail.bibleList?.length > 0"
                  >
                    <p class="font-bold">관련 성경</p>
                    <div>
                      <p
                        v-for="bible in contentDetail.bibleList"
                        :key="bible.bibleId"
                      >
                        {{ bible.bookName }} {{ bible.chapter }}장
                      </p>
                    </div>
                  </div>

                  <div
                    class="product_desc_detail mb-4"
                    v-if="contentDetail.solarTerm"
                  >
                    <p class="font-bold">관련 절기</p>
                    <div>
                      {{ contentDetail.solarTerm }}
                    </div>
                  </div>
                </div>

                <!-- 이용 안내 탭 -->
                <div
                  v-else-if="activeTab === 'usage-guide'"
                  key="usage-guide"
                  class="tab-content px-4 py-3"
                >
                  <div class="space-y-6">
                    <div>
                      <b class="font-semibold text-neutral-800">
                        사용허가정보
                      </b>
                      <div
                        class="text-sm text-neutral-700 leading-relaxed mt-1"
                      >
                        <p>
                          콘텐츠는 제3자에게 배포, 판매, 양도, 대여할 수
                          없습니다.
                        </p>
                        <p>
                          구매한 콘텐츠 원본은 SNS 포함 모든 온라인에 배포할 수
                          없습니다.
                        </p>
                        <p>
                          영상 콘텐츠로의 편집 후 유투브등의 영상채널에 배포시
                          추가 라이센스 획득 후 사용하셔야 합니다.
                        </p>
                        <p>
                          웹 및 온라인 배포, 상업적 용도, 인쇄물 제작시에는 별도
                          확장 라이센스 획득이 필요합니다.
                        </p>
                      </div>
                    </div>

                    <div>
                      <b class="font-semibold text-neutral-800"> 환불안내 </b>
                      <div
                        class="text-sm text-neutral-700 leading-relaxed mt-1"
                      >
                        <p>
                          콘텐츠 다운로드시, 원하는 콘텐츠 인지 꼭 한번 더
                          확인을 부탁드립니다.
                        </p>
                        <p>
                          결제 및 다운로드 후 1개월 이내에는 횟수 제한 없이
                          재다운로드가 가능합니다.
                        </p>
                        <p>
                          결제 및 다운로드 후 1개월 이내에 콘텐츠 자체의 오류나
                          이상등이 발견되는 경우 환불 조치가 가능하며, 환불대신
                          새파일을 받기 요청하시면 새파일 다운로드 가능합니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 저작권 정보 탭 -->
                <div
                  v-else-if="activeTab === 'copyright-info'"
                  key="copyright-info"
                  class="tab-content px-4 py-3"
                >
                  <p class="text-neutral-800 font-medium">
                    본 콘텐츠의 저작권 및 책임은 총회교육개발원에 있습니다.
                  </p>
                </div>
              </transition>
            </dd>
          </dl>

          <!-- 가격, 버튼 -->
          <div>
            <div v-if="contentDetail.isFree === false" class="flex justify-end">
              <div
                v-if="contentDetail.regularPrice === contentDetail.sellingPrice"
                class="flex gap-1 product_price"
              >
                <b class="text-2xl">{{
                  contentDetail.sellingPrice.toLocaleString()
                }}</b
                >원
              </div>
              <div v-else class="!block product_price">
                <p class="!text-lg">
                  {{ contentDetail.regularPrice.toLocaleString() }}원
                </p>
                <div class="flex gap-1 items-center">
                  <strong
                    >{{ contentDetail.discountRate.toLocaleString() }}%</strong
                  >
                  <b class="text-lg"
                    >{{ contentDetail.sellingPrice.toLocaleString() }}원</b
                  >
                </div>
              </div>
            </div>
            <div class="text-2xl" v-else>
              <b>무료</b>
            </div>

            <div class="max-lg:hidden mt-3">
              <div
                class="w-full text-center"
                v-if="contentDetail.itemStatus === 'STOP'"
              >
                <b class="text-rose-600 text-xl">판매중지</b>
              </div>
              <div v-else>
                <!-- <div class="product_desc_detail">
              <p>수량</p>
              <div class="flex items-center">
                <span  class="w-6"> {{ quantity }} </span>
                <button @click="increaseQuantity" class="mr-1">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" y="0.5" width="17" height="17" rx="2.5" fill="white" stroke="#DEE0E3"/>
                    <path d="M9.00024 3.85718V14.1429" stroke="#1B1D21" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M3.85742 9L14.1431 9" stroke="#1B1D21" stroke-width="1.5" stroke-linecap="round"/>
                  </svg>                
                </button>
                <button @click="decreaseQuantity">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" y="0.5" width="17" height="17" rx="2.5" fill="white" stroke="#DEE0E3"/>
                    <path d="M3.85718 9H14.1429" stroke="#898C92" stroke-width="1.5" stroke-linecap="round"/>
                  </svg>                
                </button>
              </div>
            </div> -->

                <!-- 상품 옵션 테스트( itemId: 136 ) -->
                <div v-if="contentDetail.itemType === 'PRODUCT'" class="mb-3">
                  <!-- TODO: 출고지 배송 정보 입력 필요 -->
                  <div class="gap-5 py-4 my-4 border-y border-neutral-200">
                    <span>배송비</span>
                    <div>
                      <div>
                        <b v-if="contentDetail.isADFActive === true">
                          {{
                            numberWithCommas(
                              contentDetail.additionalDeliveryFee
                            )
                          }}
                        </b>
                        <b v-else>
                          {{ numberWithCommas(warehouseInfo.deliveryFee) }}
                        </b>
                        원(주문시 결제) - {{ warehouseInfo.deliveryCompany }}
                      </div>
                      <div>
                        {{
                          warehouseInfo.deliveryFreeOption.toLocaleString()
                        }}원 이상 구매 시 무료
                      </div>
                    </div>
                  </div>

                  <div v-if="noneOptionItem === false">
                    <!-- {{ requiredOptionSetting }} / {{ contentDetail.optionCombined }} -->
                    <div
                      v-for="(option, index) in requiredOptionSetting"
                      :key="index"
                      class="mb-2"
                    >
                      <!-- {{ option }} -->
                      <div>
                        <div>필수 옵션</div>
                        <select
                          v-model="selectedOption[index]"
                          class="selectClass"
                          @change="combinationSelectOption(option, index, 'R')"
                        >
                          <option value="">{{ option.optionName }}</option>
                          <option
                            v-if="option.optionNodeList.length > 0"
                            :value="item"
                            v-for="item in option.optionNodeList"
                          >
                            {{ item.elementName }}(+{{
                              numberWithCommas(item.price)
                            }})
                          </option>
                          <option
                            v-if="
                              option.optionNodeList.length <= 0 && index > 0
                            "
                            value=""
                          >
                            {{ requiredOptionSetting[index - 1].optionName }}
                            옵션을 먼저 선택해 주세요.
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- {{ normalOptionSetting }} -->
                    <div
                      v-for="(option, index) in normalOptionSetting"
                      :key="index"
                    >
                      <div>
                        <div>선택 옵션</div>
                        <select
                          v-model="normalOption[index]"
                          class="selectClass"
                          @change="normalSelectOption(option, index, 'N')"
                        >
                          <option value="">{{ option.optionName }}</option>
                          <option
                            v-if="option.optionNodeList.length > 0"
                            :value="item"
                            v-for="item in option.optionNodeList"
                          >
                            {{ item.elementName }}
                            {{
                              item.price > 0 ? " - " + item.price + "원" : ""
                            }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- {{ writeSetting }} -->
                    <div v-for="(option, index) in writeSetting" :key="index">
                      <div>
                        <div>{{ option.optionName }}</div>
                        <div class="flex justify-between gap-1">
                          <input
                            type="text"
                            class="w-10/12 border border-neutral-800 p-2"
                            v-model="option.inputData"
                            @keyup.enter="makeWriteOption(option)"
                          />
                          <button
                            type="button"
                            class="border w-2/12"
                            @click="makeWriteOption(option)"
                          >
                            추가
                          </button>
                        </div>
                      </div>
                    </div>

                    <div v-if="selectedOptionList.length > 0">
                      <!-- {{ selectedOptionList }} -->
                      <div
                        v-for="(item, index) in selectedOptionList"
                        class="flex-col mt-5"
                      >
                        <div class="flex mb-2">
                          <span> {{ item.title }} </span>
                          <!--
                      <span v-for="(title, opIndex) in item.option" v-if="item.race === 'combination'">
                        <span>{{ title }}</span>
                        <span v-if="opIndex < item.option.length-1 "> /&nbsp;</span>
                      </span>
                      <span v-else>
                        <span>{{ item.option }}</span>
                      </span>
                      -->
                        </div>

                        <div class="flex justify-between items-center">
                          <div class="countBox" data-hs-input-number>
                            <div class="flex items-center gap-x-1.5">
                              <button
                                type="button"
                                class="size-6 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-md border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-white dark:hover:bg-gray-800 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                                data-hs-input-number-decrement
                                @click="optionDecreaseQuantity(item, index)"
                              >
                                <svg
                                  class="flex-shrink-0 size-3.5"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                >
                                  <path d="M5 12h14" />
                                </svg>
                              </button>

                              <input
                                class="p-0 w-6 bg-transparent border-0 text-gray-800 text-center focus:ring-0 dark:text-white"
                                type="text"
                                v-model="item.count"
                                data-hs-input-number-input
                              />

                              <button
                                type="button"
                                class="size-6 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-md border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-white dark:hover:bg-gray-800 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                                data-hs-input-number-increment
                                @click="optionIncreaseQuantity(item, index)"
                              >
                                <svg
                                  class="flex-shrink-0 size-3.5"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                >
                                  <path d="M5 12h14" />
                                  <path d="M12 5v14" />
                                </svg>
                              </button>
                            </div>
                          </div>

                          <div class="flex items-center">
                            <div class="mr-3">
                              <span class="text-xl font-bold">
                                {{ item.totalPrice }}
                              </span>
                              원
                            </div>
                            <div @click="deleteCart(item)">X</div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="flex justify-between items-baseline mt-3 pt-3 border-t"
                      >
                        <div>총 상품 가격</div>
                        <div class="text-xl">
                          <span class="text-2xl">
                            {{
                              selectedOptionList.reduce(
                                (acc, cur) => acc + cur.totalPrice,
                                0
                              )
                            }}
                          </span>
                          원
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-else>
                    <div class="countBox" data-hs-input-number>
                      <div class="flex items-center gap-x-1.5">
                        <button
                          type="button"
                          class="size-6 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-md border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-white dark:hover:bg-gray-800 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                          data-hs-input-number-decrement
                          @click="optionDecreaseQuantityNone()"
                        >
                          <svg
                            class="flex-shrink-0 size-3.5"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path d="M5 12h14" />
                          </svg>
                        </button>

                        <input
                          class="p-0 w-6 bg-transparent border-0 text-gray-800 text-center focus:ring-0 dark:text-white"
                          type="text"
                          v-model="noneOptionItemInfo.productStock"
                          data-hs-input-number-input
                        />

                        <button
                          type="button"
                          class="size-6 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-md border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-white dark:hover:bg-gray-800 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                          data-hs-input-number-increment
                          @click="optionIncreaseQuantityNone()"
                        >
                          <svg
                            class="flex-shrink-0 size-3.5"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path d="M5 12h14" />
                            <path d="M12 5v14" />
                          </svg>
                        </button>
                      </div>
                    </div>

                    <div
                      class="flex justify-between items-baseline mt-3 pt-3 border-t"
                    >
                      <div>총 상품 가격</div>
                      <div class="text-xl">
                        <span class="text-2xl">
                          {{ noneOptionItemTotalPrice }}
                        </span>
                        원
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 이미지 옵션 -->
                <div
                  v-if="contentDetail.contentType === 'IMAGE'"
                  class="grid grid-cols-5 gap-2 items-center mt-4 pt-4 border-t border-neutral-200"
                >
                  <span class="">사용용도</span>
                  <select
                    v-model="selectedLicense"
                    class="border border-neutral-800 p-2 col-span-4"
                  >
                    <option
                      v-for="imgOption in contentDetail.contentImage
                        .imageLicenseList"
                      :value="imgOption.contentImageLicenseId"
                    >
                      {{ imgOption.licenseName }} ({{
                        imgOption.licensePrice.toLocaleString()
                      }}원)
                    </option>
                  </select>
                </div>
                <div class="mt-5 flex gap-2">
                  <button
                    type="button"
                    @click="addCart"
                    class="w-full text-center px-4 py-3 border border-neutral-900 rounded"
                  >
                    장바구니 담기
                  </button>
                  <!-- <router-link to="/mypage/order"
                class="w-full text-center px-4 py-2 bg-[#0C3388] border-[#0C3388] text-white">
                바로 구매
              </router-link> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 설명 -->
      <div>
        <div
          class="p-5"
          v-if="
            contentDetail.sampleLink && contentDetail.contentType === 'VIDEO'
          "
        >
          <a
            :href="contentDetail.sampleLink"
            target="_blank"
            class="pri_btn p-4 flex justify-center items-center gap-1"
          >
            <svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.541672 12.6685C0.541672 9.58003 1.50834 6.88507 3.44167 4.58363C5.375 2.2822 7.79676 0.852657 10.7069 0.295015C10.9569 0.232537 11.1769 0.247923 11.3667 0.341174C11.5565 0.434425 11.6519 0.603676 11.6528 0.848927C11.6528 1.1007 11.5694 1.28861 11.4028 1.41263C11.2343 1.53759 11.0259 1.6341 10.7778 1.70217C8.23241 2.22904 6.1213 3.50892 4.44445 5.54179C2.76852 7.57467 1.93056 9.95024 1.93056 12.6685C1.93056 13.8202 2.08889 14.9219 2.40556 15.9738C2.72315 17.0247 3.17547 17.9945 3.7625 18.8832C3.9051 19.0819 3.975 19.2805 3.97223 19.4791C3.96945 19.6787 3.88612 19.8605 3.72223 20.0246C3.56482 20.185 3.40139 20.2419 3.23195 20.1953C3.0625 20.1487 2.91528 20.0372 2.79028 19.861C2.07269 18.8315 1.51852 17.7129 1.12778 16.5053C0.737042 15.2977 0.541672 14.0188 0.541672 12.6685ZM13.0417 25.2574C11.7009 25.2574 10.4236 25.0593 9.20973 24.6629C7.99584 24.2666 6.87825 23.7071 5.85695 22.9844C5.66991 22.8408 5.55325 22.6781 5.50695 22.4962C5.46065 22.3144 5.51389 22.1438 5.66667 21.9843C5.82593 21.8192 6.00417 21.7409 6.20139 21.7493C6.39862 21.7586 6.5963 21.8262 6.79445 21.9521C7.68149 22.5676 8.65278 23.039 9.70834 23.3663C10.7639 23.6945 11.875 23.8586 13.0417 23.8586C14.2083 23.8586 15.3194 23.6899 16.375 23.3523C17.4306 23.0157 18.4107 22.5401 19.3153 21.9256C19.5134 21.7997 19.7111 21.7307 19.9083 21.7185C20.1065 21.7073 20.2847 21.7843 20.4431 21.9493C20.5958 22.1079 20.6491 22.2799 20.6028 22.4655C20.5565 22.651 20.4398 22.8152 20.2528 22.9578C19.213 23.6805 18.0866 24.2447 16.8736 24.6504C15.6607 25.0551 14.3833 25.2574 13.0417 25.2574ZM25.5417 12.6685C25.5417 14.0188 25.3505 15.2935 24.9681 16.4927C24.5857 17.6919 24.0449 18.797 23.3458 19.8078C23.2032 20.0018 23.0431 20.1174 22.8653 20.1547C22.6875 20.192 22.5194 20.1314 22.3611 19.9729C22.1972 19.8069 22.1139 19.6246 22.1111 19.426C22.1083 19.2264 22.1778 19.0273 22.3194 18.8287C22.8898 17.9409 23.338 16.9804 23.6639 15.9472C23.9898 14.9112 24.1528 13.8183 24.1528 12.6685C24.1528 9.95024 23.3236 7.58352 21.6653 5.56837C20.006 3.55414 17.9042 2.27427 15.3597 1.72875C15.1107 1.66068 14.9023 1.56416 14.7347 1.43921C14.5681 1.31425 14.4847 1.12635 14.4847 0.875503C14.4847 0.630253 14.5755 0.461002 14.7569 0.367751C14.9384 0.2745 15.1537 0.259113 15.4028 0.321592C18.2963 0.895086 20.7093 2.32416 22.6417 4.60881C24.5741 6.89347 25.5407 9.58003 25.5417 12.6685ZM10.2639 16.6466V8.69042C10.2639 8.46382 10.3588 8.29876 10.5486 8.19525C10.7384 8.09081 10.931 8.10247 11.1264 8.23022L17.2667 12.1817C17.4398 12.303 17.5264 12.4652 17.5264 12.6685C17.5264 12.8718 17.4398 13.0341 17.2667 13.1553L11.1278 17.1068C10.9315 17.2346 10.7384 17.2462 10.5486 17.1418C10.3588 17.0383 10.2639 16.8732 10.2639 16.6466Z"
                fill="#0C3388"
              />
            </svg>
            <h3>샘플 영상 보기</h3>
          </a>
        </div>

        <div
          v-else-if="
            contentDetail.sampleLink && contentDetail.contentType === 'MUSIC'
          "
          class="p-2"
        >
          <div
            class="pri_btn p-4 flex justify-center items-center gap-1 max-md:flex-col"
          >
            <h3 class="mr-2">샘플 듣기</h3>
            <audio ref="audioPlayer" controls controlsList="nodownload">
              <source :src="contentDetail.sampleLink" type="audio/mpeg" />
              ※ 사용 중인 브라우저에서 음악 플레이어를 지원하지 않습니다.
            </audio>
          </div>
        </div>

        <div
          class="mall_detail_img mx-auto"
          :class="{ folded: isImageFolded, inactive: togglerActive }"
        >
          <p class="ql-container">
            <span class="ql-editor" v-html="contentDetail.description"></span>
          </p>

          <div v-if="togglerActive" class="mall_detail_toggle">
            <button type="button" @click="toggleImage">
              {{ isImageFolded ? "상품 설명 더보기" : "상품 설명 닫기" }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 리뷰 섹션-->
    <section class="!py-12 border-y border-neutral-200">
      <!-- <div class="w-full flex items-center gap-2 mb-6">
        <h3 class="font-bold">AI 리뷰 요약</h3>
        <ul
          class="flex text-sm justify-center items-center text-center gap-2 ml-2"
        >
          <li
            v-for="item in popoverData"
            :key="item.id"
            class="popover-item"
            @click="togglePopover(item.id)"
            @mouseenter="showPopover(item.id)"
            @mouseleave="hidePopover(item.id)"
          >
            {{ item.icon }} {{ item.label }}

            <div v-if="activePopover === item.id" class="popover-content">
              {{ item.content }}
              <div class="popover-arrow"></div>
            </div>
          </li>
        </ul>
      </div>

      <div v-if="getAllReviewPhotos().length > 0" class="mb-5 max-lg:px-3">
        <ul class="grid grid-cols-4 lg:grid-cols-8 gap-2">
          <li
            v-for="(photo, index) in getAllReviewPhotos().slice(0, 7)"
            :key="index"
            class="w-full h-24 bg-neutral-200 cursor-pointer rounded overflow-hidden transition-opacity hover:opacity-80"
            @click="openPhotoModal(index)"
          >
            <img
              :src="
                photo.startsWith('http')
                  ? photo
                  : `https://eduwind-api.nodeblack.net/${photo}`
              "
              :alt="`리뷰 사진 ${index + 1}`"
              class="w-full h-full object-cover"
              @error="$event.target.src = '@/assets/img/null_img.jpg'"
            />
          </li>

          <li
            v-if="getAllReviewPhotos().length > 7"
            class="w-full h-24 bg-neutral-200 cursor-pointer relative rounded overflow-hidden transition-opacity hover:opacity-80"
            @click="viewAllPhotos"
          >
            <img
              :src="
                getAllReviewPhotos()[7].startsWith('http')
                  ? getAllReviewPhotos()[7]
                  : `https://eduwind-api.nodeblack.net/${
                      getAllReviewPhotos()[7]
                    }`
              "
              :alt="`더보기`"
              class="w-full h-full object-cover"
            />
            <div
              class="absolute bottom-0 left-0 w-full h-full bg-neutral-900/60 flex flex-col justify-center items-center text-white"
            >
              <p class="text-sm font-medium">더보기</p>
              <p class="text-xs">+{{ getAllReviewPhotos().length - 7 }}</p>
            </div>
          </li>
        </ul>
      </div> -->

      <h3 class="font-bold mb-6">콘텐츠 리뷰</h3>
      <ul v-if="reviewList.reviewList && reviewList.reviewList.length > 0">
        <li
          v-for="review in reviewList.reviewList"
          class="p-3 mb-3 not(:last-child):border-b border-neutral-200"
        >
          <div @click="getReviewDetail(review.reviewId)">
            <div class="flex items-center gap-x-2 mb-2">
              <p class="text-sm text-neutral-500">
                {{ review.memberName }}
              </p>

              <span
                class="ml-2 pl-3 leading-none border-l text-sm text-neutral-400"
                >2025.02.24</span
              >
            </div>

            <div class="flex gap-1 items-center cursor-pointer">
              <p class="truncate max-w-[50%]">{{ review.reviewTitle }}</p>
              <button
                type="button"
                class="flex items-center gap-2 p-1 border border-neutral-400 text-xs ml-2"
              >
                <svg
                  width="10"
                  height="7"
                  viewBox="0 0 10 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.833323 1.49999L4.99999 5.66666L9.16666 1.49999"
                    stroke="black"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>

            <div
              v-if="
                reviewDetail.reviewId &&
                reviewDetail.reviewId === review.reviewId
              "
              class="mt-2 p-2 font-light"
            >
              <div
                v-html="reviewDetail.reviewDescription"
                class="reviewDetailContainer"
              ></div>
            </div>
          </div>
        </li>
      </ul>
      <div class="flex flex-col items-center justify-center">
        <h3 class="text-lg text-neutral-500 mb-6">리뷰가 없습니다.</h3>
        <button class="pri_btn_bg px-4 py-3 rounded">
          첫번째 리뷰 작성하기
        </button>
      </div>
    </section>

    <!-- 연관 콘텐츠 -->
    <section
      class="pt-5"
      v-if="
        contentDetail.relationItemList &&
        contentDetail.relationItemList.length > 0
      "
    >
      <h3 class="font-bold mb-6">연관 콘텐츠</h3>

      <menu class="product_grid_container">
        <li
          v-for="related in contentDetail.relationItemList"
          :key="related.itemId"
          class="product_grid_wr"
        >
          <!-- 상품 thumb -->
          <div
            class="product_thumb mb-2 cursor-pointer"
            @click="refreshPage(related.itemId)"
          >
            <img
              v-if="related.thumbnailLink"
              :src="
                'https://eduwind-api.nodeblack.net/' + related.thumbnailLink
              "
            />
            <img
              v-else
              src="@/assets/img/null_img.jpg"
              :alt="contentDetail.title"
            />
          </div>

          <!-- 상품설명 -->
          <div class="product_desc space-y-2">
            <div class="flex gap-1" v-if="related.tagList.length > 0">
              <p
                v-for="tag in related.tagList"
                :key="tag"
                class="product_sub_tt"
              >
                {{ tag }}
              </p>
            </div>
            <p
              class="product_tt cursor-pointer"
              @click="refreshPage(related.itemId)"
            >
              {{ related.title }}
            </p>
            <div
              class="flex gap-1 product_price"
              v-if="related.sellingPrice > 0"
            >
              <strong v-if="related.discountRate > 0"
                >{{ related.discountRate }}%</strong
              >
              {{ related.sellingPrice.toLocaleString() }} 원
              <p v-if="related.sellingPrice < related.regularPrice">
                {{ related.regularPrice.toLocaleString() }} 원
              </p>
            </div>
            <div v-else>무료</div>
          </div>
        </li>
      </menu>
    </section>

    <div class="lg:hidden m_detail mt-5 pt-5 border-y border-neutral-100">
      <!-- <div class="product_desc_detail">
        <p>수량</p>
        <div class="flex items-center">
          <span  class="w-6"> {{ quantity }} </span>
          <button @click="increaseQuantity" class="mr-1">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="17" height="17" rx="2.5" fill="white" stroke="#DEE0E3"/>
              <path d="M9.00024 3.85718V14.1429" stroke="#1B1D21" stroke-width="1.5" stroke-linecap="round"/>
              <path d="M3.85742 9L14.1431 9" stroke="#1B1D21" stroke-width="1.5" stroke-linecap="round"/>
            </svg>                
          </button>
          <button @click="decreaseQuantity">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="17" height="17" rx="2.5" fill="white" stroke="#DEE0E3"/>
              <path d="M3.85718 9H14.1429" stroke="#898C92" stroke-width="1.5" stroke-linecap="round"/>
            </svg>                
          </button>
        </div>
      </div> -->

      <!-- 이미지 옵션 -->
      <div
        v-if="contentDetail.contentType === 'IMAGE'"
        class="flex gap-2 items-center"
      >
        <span>사용용도</span>
        <select
          v-model="selectedLicense"
          class="border border-neutral-800 p-2 flex-1"
        >
          <option
            v-for="imgOption in contentDetail.contentImage.imageLicenseList"
            :value="imgOption.contentImageLicenseId"
          >
            {{ imgOption.licenseName }} ({{
              imgOption.licensePrice.toLocaleString()
            }}원)
          </option>
        </select>
        <!-- 용도 설명 -->
        <!-- <button>
          ?
        </button> -->
      </div>

      <div v-if="contentDetail.itemType === 'PRODUCT'" class="mb-3">
        <!-- TODO: 출고지 배송 정보 입력 필요 -->
        <div class="gap-5 py-4 my-4 border-y border-neutral-200">
          <span>배송비</span>
          <div>
            <div>
              <b v-if="contentDetail.isADFActive === true">
                {{ numberWithCommas(contentDetail.additionalDeliveryFee) }}
              </b>
              <b v-else> {{ numberWithCommas(warehouseInfo.deliveryFee) }} </b>
              원(주문시 결제) - {{ warehouseInfo.deliveryCompany }}
            </div>
            <div>
              {{ warehouseInfo.deliveryFreeOption }}원 이상 구매 시 무료
            </div>
          </div>
        </div>

        <!-- {{ requiredOptionSetting }} -->

        <!-- {{ contentDetail.optionCombined }} -->

        <div
          v-for="(option, index) in requiredOptionSetting"
          :key="index"
          class="mb-2"
        >
          <!-- {{ option }} -->
          <div>
            <div>필수 옵션</div>
            <select
              v-model="selectedOption[index]"
              class="selectClass"
              @change="combinationSelectOption(option, index, 'R')"
            >
              <option value="">{{ option.optionName }}</option>
              <option
                v-if="option.optionNodeList.length > 0"
                :value="item"
                v-for="item in option.optionNodeList"
              >
                {{ item.elementName }}(+{{ numberWithCommas(item.price) }})
              </option>
              <option
                v-if="option.optionNodeList.length <= 0 && index > 0"
                value=""
              >
                {{ requiredOptionSetting[index - 1].optionName }} 옵션을 먼저
                선택해 주세요.
              </option>
            </select>
          </div>
        </div>

        <!-- {{ normalOptionSetting }} -->

        <div v-for="(option, index) in normalOptionSetting" :key="index">
          <div>
            <div>선택 옵션</div>
            <select
              v-model="normalOption[index]"
              class="selectClass"
              @change="normalSelectOption(option, index, 'N')"
            >
              <option value="">{{ option.optionName }}</option>
              <option
                v-if="option.optionNodeList.length > 0"
                :value="item"
                v-for="item in option.optionNodeList"
              >
                {{ item.elementName }}
                {{ item.price > 0 ? " - " + item.price + "원" : "" }}
              </option>
            </select>
          </div>
        </div>

        <!-- {{ writeSetting }} -->

        <div v-for="(option, index) in writeSetting" :key="index">
          <div>
            <div>{{ option.optionName }}</div>
            <div class="flex justify-between gap-1">
              <input
                type="text"
                class="w-10/12 border border-neutral-800 p-2"
                v-model="option.inputData"
                @keyup.enter="makeWriteOption(option)"
              />
              <button
                type="button"
                class="border w-2/12"
                @click="makeWriteOption(option)"
              >
                추가
              </button>
            </div>
          </div>
        </div>

        <!--
        <div v-for="(option, index) in requiredWriteSetting" :key="index">
          {{ option }}
          <div>
            <div> {{ option.optionName }} </div>
            <div>
              <input type="text" class="w-full border border-neutral-800 p-2" @keyup.enter="makeWriteOption(option, $event)">
            </div>
          </div>
        </div>
        -->

        <!--
        <div v-for="(option, index) in requireOptionSetting" :key="index">
          <div>
            <div> {{ option.title }} </div>
            <div>
              <input type="text" class="w-full border border-neutral-800 p-2" @keyup.enter="normalSelectOption( option )">
            </div>
          </div>
        </div>

        <div v-for="(option, index) in normalOptionSetting" :key="index">
          <div>
            <select class="selectClass" @change="normalSelectOption( option )">
              <option value=""> {{ option.title }} </option>
              <option v-if="option.values.length > 0" :value="item" v-for="item in option.values">{{item}}</option>
            </select>
          </div>
        </div>
        -->

        <!--
        {{ selectedOption }} <br /><br />
        {{ selectedOptionList }}
        -->

        <!-- {{ selectedOptionList }} -->

        <div v-if="selectedOptionList.length > 0">
          <!-- {{ selectedOptionList }} -->
          <div
            v-for="(item, index) in selectedOptionList"
            class="flex-col mt-5"
          >
            <div class="flex mb-2">
              <span> {{ item.title }} </span>
              <!--
              <span v-for="(title, opIndex) in item.option" v-if="item.race === 'combination'">
                <span>{{ title }}</span>
                <span v-if="opIndex < item.option.length-1 "> /&nbsp;</span>
              </span>
              <span v-else>
                <span>{{ item.option }}</span>
              </span>
              -->
            </div>

            <div class="flex justify-between items-center">
              <div class="countBox" data-hs-input-number>
                <div class="flex items-center gap-x-1.5">
                  <button
                    type="button"
                    class="size-6 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-md border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-white dark:hover:bg-gray-800 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                    data-hs-input-number-decrement
                    @click="optionDecreaseQuantity(item, index)"
                  >
                    <svg
                      class="flex-shrink-0 size-3.5"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M5 12h14" />
                    </svg>
                  </button>

                  <input
                    class="p-0 w-6 bg-transparent border-0 text-gray-800 text-center focus:ring-0 dark:text-white"
                    type="text"
                    v-model="item.count"
                    data-hs-input-number-input
                  />

                  <button
                    type="button"
                    class="size-6 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-md border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-white dark:hover:bg-gray-800 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                    data-hs-input-number-increment
                    @click="optionIncreaseQuantity(item, index)"
                  >
                    <svg
                      class="flex-shrink-0 size-3.5"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M5 12h14" />
                      <path d="M12 5v14" />
                    </svg>
                  </button>
                </div>
              </div>

              <div class="flex items-center">
                <div class="mr-3">
                  <span class="text-xl font-bold"> {{ item.totalPrice }} </span>
                  원
                </div>
                <div @click="deleteCart(item)">X</div>
              </div>
            </div>
          </div>

          <div class="flex justify-between items-baseline mt-3 pt-3 border-t">
            <div>총 상품 가격</div>
            <div class="text-xl">
              <span class="text-2xl">
                {{
                  selectedOptionList.reduce(
                    (acc, cur) => acc + cur.totalPrice,
                    0
                  )
                }}
              </span>
              원
            </div>
          </div>
        </div>

        <!--
        <div v-for="(option, index) in optionList" :key="index">
          <h3>{{ option.title }}</h3>
          <select v-model="selectedOptions[index]">
            <option v-for="value in option.values" :value="value.title">{{ value.title }}</option>
          </select>
          <div v-if="option.values.length > 0">
            <h4 v-if="selectedOptions[index] && option.values.find(v => v.title === selectedOptions[index]).subOptions">
              {{ option.values.find(v => v.title === selectedOptions[index]).subOptions[0].title }}
            </h4>
            <select v-if="selectedOptions[index] && option.values.find(v => v.title === selectedOptions[index]).subOptions" v-model="selectedSubOptions[index]">
              <option v-for="subValue in option.values.find(v => v.title === selectedOptions[index]).subOptions[0].values" :value="subValue">{{ subValue }}</option>
            </select>
          </div>
        </div>

        {{ selectedOptions }} / {{ selectedSubOptions }}
        -->
      </div>

      <div class="lg:mt-5 flex gap-2">
        <button
          type="button"
          @click="addCart"
          class="w-full text-center px-4 py-3 border border-neutral-900 rounded"
        >
          장바구니 담기
        </button>
        <!-- <router-link to="/mypage/order"
          class="w-full text-center px-4 py-2 bg-[#0C3388] border-[#0C3388] text-white">
          바로 구매
        </router-link> -->
      </div>
    </div>

    <router-link
      to="/mall"
      type="button"
      class="w-fit flex items-center mt-8 gap-4 px-6 py-3 mx-auto rounded pri_btn_bg"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="19"
        viewBox="0 0 20 19"
        fill="none"
      >
        <path d="M9.5 1.5L1.5 9.5L9.5 17.5" stroke="white" stroke-width="2" />
        <path d="M19.5 9.5H1.5" stroke="white" stroke-width="2" />
      </svg>
      목록으로
    </router-link>

    <!-- 리뷰 사진 모달 -->
    <ReviewPhotoModal
      :isVisible="isPhotoModalVisible"
      :photos="reviewPhotos"
      :initialIndex="selectedPhotoIndex"
      @close="closePhotoModal"
      @photoChange="handlePhotoChange"
    />
  </main>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import router from "@/router";
import axios from "axios";
import { openLoginDialog } from "@/composables/useLoginDialog";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import { numberWithCommas } from "@/assets/js/util.js";

import { editCart } from "@/assets/js/cart.js";
import ReviewPhotoModal from "@/components/ReviewPhotoModal.vue";

const quantity = ref(1);
const isImageFolded = ref(false);
const togglerActive = ref(false);

const contentDetail = ref({});
const selectedLicense = ref(null);

// 팝오버 관련 변수들
const activePopover = ref(null);
const popoverTimer = ref(null);

// 팝오버 데이터 정의
const popoverData = ref([
  {
    id: "satisfaction",
    icon: "👍",
    label: "만족(98%, 불만족 1%)",
    content: "많은 고객님들께서 컨텐츠 내용에 만족하셨어요.",
  },
  {
    id: "elementary",
    icon: "🏫",
    label: "유년부(75%, 유치부 20%)",
    content: "유년부 및 유치부 공과로 많이 사용되었어요.",
  },
  {
    id: "hanabible",
    icon: "📖",
    label: "하나바이블",
    content: "하나바이블 공과로 많이 사용되었어요.",
  },
]);

const route = useRoute();
const itemId = route.params.itemId;

// 탭 관련 상태 관리
const activeTab = ref("product-info"); // 활성 탭 상태

// 이전 페이지로 이동하는 함수
const goBack = () => {
  // 브라우저 히스토리가 있으면 뒤로가기, 없으면 콘텐츠 몰로 이동
  if (window.history.length > 1) {
    router.go(-1);
  } else {
    router.push("/mall");
  }
};

const reviewList = ref({});
const reviewDetail = ref({});

// 리뷰 사진 모달 관련 상태
const isPhotoModalVisible = ref(false);
const reviewPhotos = ref([]);
const selectedPhotoIndex = ref(0);
// 옵션 업는 상풍 관련 변수들
const noneOptionItem = ref(false); // 옵션 있는 상품인지 아닌지
const noneOptionItemInfo = ref({
  itemId: null,
  isSelected: true,
  quantity: null,
  licenseId: null,
  productStock: 1, // 옵션 없는 상품 보낼때 사용
  command: null,
}); // 옵션 없는 상품 정보
const noneOptionItemPrice = ref(0); // 옵션 없는 상품 가격
const noneOptionItemTotalPrice = ref(0); // 옵션 없는 상품 총 가격

// 조합형 옵션 예시
const combinationOptionSetting = ref([
  {
    idx: 1,
    type: "default",
    title: "사이즈",
    values: ["S", "M", "L", "XL"],
    isRequire: true,
    price: 11000,
  },
  {
    idx: 2,
    type: "default",
    title: "색상",
    values: [],
    isRequire: true,
    price: 12000,
  },
  {
    idx: 3,
    type: "default",
    title: "재질",
    values: [],
    isRequire: true,
    price: 13000,
  },
]);
const selectedOption = ref([]);
const selectedOptionList = ref([]);
const selectedOptionTitle = ref(null);

const normalOption = ref([]);
// 일반 선택 옵션 예시
const normalOptionSetting = ref([]);

const warehouseInfo = ref({});

// 리뷰 사진 모달 관련 함수들
/**
 * 리뷰 사진들을 수집하는 함수
 * @return {Array} 모든 리뷰 사진들의 배열
 */
const getAllReviewPhotos = () => {
  const photos = [];

  if (reviewList.value.reviewList) {
    reviewList.value.reviewList.forEach((review) => {
      if (review.photoList && review.photoList.length > 0) {
        review.photoList.forEach((photo) => {
          photos.push(photo);
        });
      }
    });
  }

  return photos;
};

/**
 * 사진 클릭 시 모달 열기
 * @param {number} photoIndex - 선택된 사진의 인덱스
 */
const openPhotoModal = (photoIndex = 0) => {
  reviewPhotos.value = getAllReviewPhotos();
  selectedPhotoIndex.value = photoIndex;
  isPhotoModalVisible.value = true;
};

/**
 * 더보기 버튼 클릭 시 모든 사진 보기
 */
const viewAllPhotos = () => {
  openPhotoModal(0);
};

/**
 * 모달 닫기
 */
const closePhotoModal = () => {
  isPhotoModalVisible.value = false;
};

/**
 * 모달에서 사진 변경 시 호출
 * @param {number} newIndex - 새로운 사진 인덱스
 */
const handlePhotoChange = (newIndex) => {
  selectedPhotoIndex.value = newIndex;
};

const combinationSelectOption = async (option, idx, require) => {
  console.group(
    ` combinationSelectOption ------------------------------------------- `
  );

  console.log(option);
  const selectOption =
    require === "R" ? requiredOptionSetting.value : optionSetting.value;
  console.log(selectOption);

  console.log(selectedOption.value);
  console.log(selectedOption.value[idx]);

  const optionCombined = contentDetail.value.optionCombined;
  selectedOption.value[idx].optionCombined = optionCombined;

  // 조합형
  if (optionCombined === true) {
    const optionCount = selectOption.length - 1;
    console.log(optionCount, idx);
    if (optionCount <= idx) {
      addOption(
        selectedOption.value[idx],
        option.optionId,
        require,
        optionCombined
      );
    } else {
      getOptionList(idx);
    }
  }
  // 비조합형
  else {
    selectedOption.value[`combinationId${idx + 1}`] =
      selectedOption.value.combinationId;
    selectedOption.value.combinationId = null;

    // selectedOption.value[idx][`combinationId${idx + 1}`] = option.combinationId;
    console.log(selectedOption.value[`combinationId${idx + 1}`]);
    console.log(selectedOption.value);

    const optionCount = selectOption.length - 1;
    console.log(optionCount, idx);

    console.groupEnd();
    if (optionCount <= idx) {
      addOption(selectedOption.value, option.optionId, require, optionCombined);
    }
    // addOption(selectedOption.value[idx], option.optionId, require, optionCombined);
  }

  // 일반 옵션 예시
  const normalOptionSetting = ref([
    {
      idx: 4,
      type: "default",
      title: "선택옵션1",
      values: ["선택옵션1-1", "선택옵션1-2"],
      isRequire: false,
      price: 0,
    },
    {
      idx: 5,
      type: "default",
      title: "선택옵션2",
      values: ["선택옵션2-1", "선택옵션2-2", "선택옵션2-3"],
      isRequire: false,
      price: 1000,
    },
  ]);
};
// 예시
const getOptionList = (idx) => {
  console.log("getOptionList");
  console.log(selectedOption.value[idx]);
  let elements = "";
  selectedOption.value.forEach((val, index) => {
    if (val !== "" && val !== undefined && val !== null) {
      elements += (index === 0 ? "?" : "&") + `elements=${val.elementName}`;
    }
  });
  console.log(elements);

  // const url = `/api/product/${itemId}/options?elements=A&elements=1`;
  const url = `/new_api/product/${itemId}/options${elements}`;
  axios
    .get(url)
    .then((res) => {
      console.log(res.data.data.paths);
      requiredOptionSetting.value[idx + 1].optionNodeList = res.data.data.paths;
      selectedOptionTitle.value =
        selectedOptionTitle.value !== null
          ? selectedOptionTitle.value +
            " > " +
            selectedOption.value[idx].elementName
          : selectedOption.value[idx].elementName;
      // selectedOptionTitle.value + ' > ' + selectedOption.value[idx].elementName;
    })
    .catch((error) => {
      console.error(error);
    });
};

const normalSelectOption = (option, idx, require) => {
  console.group(
    ` normalSelectOption ------------------------------------------- `
  );
  console.log(option);
  // const selectedOption = event.target.value;
  const selectedOption = normalOption.value[idx];
  if (selectedOption !== "") {
    const item = {
      optionIdx: selectedOption.optionId,
      race: "normal",
      type: option.type,
      title: selectedOption.elementName,
      option: selectedOption.combinationId,
      count: 1,
      price: selectedOption.price,
      totalPrice: selectedOption.price * 1,
      value: null,
    };

    console.log(item);
    // selectedOptionList 중복 확인
    let overlap = false;

    if (item.type === "input") {
      selectedOptionList.value.forEach((val, index) => {
        if (val.optionIdx === item.optionIdx) {
          alert(" .");
          overlap = true;
          return false;
        }
      });
    } else {
      selectedOptionList.value.forEach((val, index) => {
        if (JSON.stringify(val.option) === JSON.stringify(item.option)) {
          alert("이미 선택된 옵션입니다.");
          overlap = true;
          return false;
        }
      });
    }

    if (overlap === false) {
      selectedOptionList.value.push(item);
    }

    normalOption.value[idx] = ""; // 초기화
  }

  console.groupEnd();
};

/**
 * 옵션 추가
 * @param option
 * @param optionId
 * @param require - 필수항목
 * @param optionCombined - 조합, 비조합 판단
 */
const addOption = (option, optionId, require = null, optionCombined) => {
  console.group(` addOption ------------------------------------------- `);
  console.log(`++++++++++++++++++++++++++++++++++++++++`);
  console.log(optionCombined);
  console.log(option);
  console.log(`++++++++++++++++++++++++++++++++++++++++`);
  let item;
  if (optionCombined === false) {
    const title = option.map((val) => val.elementName).join(" > ");
    const price = option.reduce((acc, cur) => acc + cur.price, 0);
    // optionIdx: optionId,
    item = {
      optionIdx: null,
      race: optionCombined === "Y" ? "combination" : "noneCombination",
      type: option.type,
      title: title,
      option: option.combinationId,
      count: 1,
      price: price,
      totalPrice: price * 1,
      value: option.value,
      optionMessage: option.optionMessage ? option.optionMessage : null,
      require: require,
      combinationId1: option[0].combinationId,
      combinationId2: option[1].combinationId,
      combinationId3: option[2].combinationId,
    };

    console.log(`item +++++++++++++++++++++++++++++++++++++++++++++ `);
    console.log(item);
    console.log(`item +++++++++++++++++++++++++++++++++++++++++++++ `);
  } else {
    item = {
      optionIdx: optionId,
      race: optionCombined === "Y" ? "combination" : "noneCombination",
      type: option.type,
      title: option.title ? option.title : null,
      option: option.combinationId,
      count: 1,
      price: option.price,
      totalPrice: option.price * 1,
      value: option.value,
      optionMessage: option.optionMessage ? option.optionMessage : null,
      require: require,
      combinationId1: option.combinationId1,
      combinationId2: option.combinationId2,
      combinationId3: option.combinationId3,
    };
    if (option.value) {
      item.value = option.value;
    }
  }

  console.log(item);

  // selectedOptionList 중복 확인
  let overlap = false;
  selectedOptionList.value.forEach((val, index) => {
    if (
      JSON.stringify(val.option) === JSON.stringify(item.option) &&
      JSON.stringify(val.combinationId1) ===
        JSON.stringify(item.combinationId1) &&
      JSON.stringify(val.combinationId2) ===
        JSON.stringify(item.combinationId2) &&
      JSON.stringify(val.combinationId3) === JSON.stringify(item.combinationId3)
    ) {
      alert("이미 선택된 옵션입니다..");
      overlap = true;
      return false;
    }
  });

  if (overlap === false) {
    /*console.log(item);
    console.log(item.title);
    console.log(`selectedOptionTitle.value : ${selectedOptionTitle.value}`);*/
    if (item.title === null) {
      if (selectedOptionTitle.value !== null) {
        item.title = selectedOptionTitle.value + " > " + option.elementName;
      } else {
        item.title = option.elementName;
      }
    }
    selectedOptionList.value.push(item);
    selectedOptionTitle.value = null; // 상품명 초기화
  }
  selectedOption.value = new Array(combinationOptionSetting.value.length).fill(
    ""
  );

  console.groupEnd();
};

const makeWriteOption = (option) => {
  console.log(option.inputData);
  // console.log(option.optionType);

  const writeOption = {
    type: option.optionType,
    title: option.inputData,
    combinationId: option.optionNodeList[0].combinationId,
    price: option.optionNodeList[0].price,
    value: null,
    optionMessage: option.inputData,
  };
  option.inputData = ""; // 초기화
  addOption(writeOption, option.optionId);
};

const optionDecreaseQuantity = (item, index) => {
  // selectedOptionList.value[index].count--;
  const option = selectedOptionList.value[index];
  if (option.count > 1) {
    option.count--;
    option.totalPrice = option.price * option.count;
  } else {
    alert("수량은 1 이상이어야 합니다.");
  }
};

const optionIncreaseQuantity = (item, index) => {
  const option = selectedOptionList.value[index];
  option.count++;
  option.totalPrice = option.price * option.count;
};

const optionDecreaseQuantityNone = () => {
  // selectedOptionList.value[index].count--;

  if (noneOptionItemInfo.value.productStock > 1) {
    noneOptionItemInfo.value.productStock--;
    noneOptionItemTotalPrice.value =
      noneOptionItemPrice.value * noneOptionItemInfo.value.productStock;
  } else {
    alert("수량은 1 이상이어야 합니다.");
  }
};

const optionIncreaseQuantityNone = () => {
  noneOptionItemInfo.value.productStock++;
  noneOptionItemTotalPrice.value =
    noneOptionItemPrice.value * noneOptionItemInfo.value.productStock;
};

/* ************************************************************************************************************** */

const requiredOptionSetting = ref([]); // 필수 옵션 목록
// const requiredWriteSetting = ref([]);    // 옵션 목록
const writeSetting = ref([]); // 옵션 목록
const optionSetting = ref([]); // 옵션 목록

/* ************************************************************************************************************** */

// 상품 상세 GET
const getItemInfo = async () => {
  try {
    const url = `/new_api/customer/item/${itemId}`;
    const { data, status } = await axios.get(url);
    const item = data.data;
    console.log(item);
    item.itemType = item.code.startsWith("P") ? "PRODUCT" : "CONTENT";
    item.itemId = item.code.startsWith("P") ? item.productId : item.contentId;
    contentDetail.value = item;
    if (item.itemType === "PRODUCT") {
      // TODO: 두번째 부터 옵션 리스트들 초기화
      item.optionList.forEach((option, index) => {
        if (index > 0 && option.depth === 1) {
          option.optionNodeList = [];
        }
      });

      // console.log(item.optionList);

      // 필수 옵션
      requiredOptionSetting.value = item.optionList.filter(
        (option) => option.required === true && option.optionType === "TREE"
      );
      /*requiredOptionSetting.value.map((option, index) => {
        option.required = true;
      });*/
      // 선택 옵션
      normalOptionSetting.value = item.optionList.filter(
        (option) => option.required === false && option.optionType === "TREE"
      );
      // 입력 옵션
      writeSetting.value = item.optionList.filter(
        (option) => option.optionType === "WRITING"
      );

      noneOptionItem.value =
        requiredOptionSetting.value.length === 0 &&
        normalOptionSetting.value.length === 0 &&
        writeSetting.value.length === 0;
      if (noneOptionItem.value === true) {
        noneOptionItemInfo.itemId = item.itemId;
        noneOptionItemPrice.value = item.sellingPrice;
        noneOptionItemTotalPrice.value = item.sellingPrice;
      }

      // 출고지 정보
      warehouseInfo.value = item.warehouse;
    }

    if (contentDetail.value.contentImage !== undefined) {
      if (contentDetail.value.contentImage.imageLicenseList.length > 0) {
        selectedLicense.value =
          contentDetail.value.contentImage.imageLicenseList[0].contentImageLicenseId;
      }
    }
  } catch (err) {
    console.error(err);
  }
};

// 상품 리뷰 목록 GET
const getReviewList = async () => {
  try {
    const res = await axios.get(
      "/new_api/review/list?page=1&size=10&itemId=" + itemId
    );
    reviewList.value = res.data.data;

    // TODO: 개발용 더미 데이터 추가 (실제 배포시 제거 필요)
    addDummyPhotosToReviews();
  } catch (err) {
    console.error(err);
    // API 호출 실패시에도 더미 데이터로 테스트 가능하도록
    createDummyReviewData();
  }
};

/**
 * 개발/테스트용 더미 사진 데이터 추가 함수
 * 실제 배포시에는 제거해야 함
 */
const addDummyPhotosToReviews = () => {
  if (!reviewList.value.reviewList) {
    reviewList.value.reviewList = [];
  }

  // 더미 사진 URL 배열 (무료 이미지 서비스 이용)
  const dummyPhotos = [
    "https://picsum.photos/400/400?random=1",
    "https://picsum.photos/400/400?random=2",
    "https://picsum.photos/400/400?random=3",
    "https://picsum.photos/400/400?random=4",
    "https://picsum.photos/400/400?random=5",
    "https://picsum.photos/400/400?random=6",
    "https://picsum.photos/400/400?random=7",
    "https://picsum.photos/400/400?random=8",
    "https://picsum.photos/400/400?random=9",
    "https://picsum.photos/400/400?random=10",
    "https://picsum.photos/400/400?random=11",
    "https://picsum.photos/400/400?random=12",
  ];

  // 기존 리뷰가 있다면 더미 사진 추가
  if (reviewList.value.reviewList.length > 0) {
    reviewList.value.reviewList.forEach((review, index) => {
      if (!review.photoList) {
        review.photoList = [];
      }

      // 각 리뷰에 1-3개의 랜덤 사진 추가
      const photoCount = Math.floor(Math.random() * 3) + 1;
      const startIndex = (index * 3) % dummyPhotos.length;

      for (let i = 0; i < photoCount; i++) {
        const photoIndex = (startIndex + i) % dummyPhotos.length;
        review.photoList.push(dummyPhotos[photoIndex]);
      }
    });
  }
};

// 상품 리뷰 상세 GET
const getReviewDetail = async (id) => {
  try {
    const res = await axios.get("/new_api/review/" + id);
    console.log(res);
    reviewDetail.value = res.data.data;
  } catch (err) {
    console.error(err);
  }
};

onMounted(async () => {
  await getItemInfo();
  await getReviewList();

  checkImageHeight();
  window.addEventListener("resize", checkImageHeight);

  selectedOption.value = new Array(requiredOptionSetting.value.length).fill("");
  normalOption.value = new Array(normalOptionSetting.value.length).fill("");
});

// 상세이미지 사이즈에 따른 버튼 출력
const checkImageHeight = () => {
  const detailImage = document.querySelector('[data-ref="detailImage"]');
  if (detailImage) {
    const imageHeight = detailImage.clientHeight;
    const viewportHeight =
      window.innerHeight || document.documentElement.clientHeight;
    if (imageHeight > viewportHeight * 0.5) {
      isImageFolded.value = true;
      togglerActive.value = true;
    }
  }
};

const toggleImage = () => {
  isImageFolded.value = !isImageFolded.value;
};

onUnmounted(() => {
  window.removeEventListener("resize", checkImageHeight);
});

// 상품 수량 증감
const increaseQuantity = () => {
  quantity.value++;
};

const decreaseQuantity = () => {
  if (quantity.value > 1) {
    quantity.value--;
  } else {
    alert("수량은 1 이상이어야 합니다.");
  }
};

// 장바구니 추가
const addCart = async () => {
  const token = localStorage.getItem("authorization");
  if (!token) {
    openLoginDialog();
    return;
  }
  console.log(` addCart START ------------------------------- `);

  console.log(contentDetail.value.itemId, contentDetail.value.itemType);

  /**
   * 1. 콘텐츠 이미지 제외 장바구니 담기
   * 2. 콘텐츠 이미지 장바구니 담기
   * 3. 상품 옵션 장바구니 담기
   */
  // isSelected : true, // 장바구니 담기시 체크 되는 부분
  let param = {
    itemId: null,
    quantity: null,
    licenseId: null,
    productStock: null,
    productOptionList: null,
  };
  param.itemId = contentDetail.value.itemId;
  // 콘텐츠 데이터 추가
  if (contentDetail.value.itemType === "CONTENT") {
    // 이미지 - 라이센스 선택 추가
    param.quantity = 1;
    if (contentDetail.value.contentType === "IMAGE") {
      param.licenseId = selectedLicense.value;
      param.quantity = quantity.value;
    }
  }
  // 상품 데이터 추가
  else {
    if (noneOptionItem.value === true) {
      param.productStock = noneOptionItemInfo.value.productStock;
    } else {
      param.productStock = "";
      // param.productOptionList = "";
      console.log(selectedOptionList.value);
      let productOptionList = [];
      selectedOptionList.value.forEach((item, index) => {
        productOptionList.push({
          require: item.require === "R",
          optionId: item.optionIdx,
          combinationId: item.option,
          quantity: item.count,
          optionMessage: item.optionMessage, // 입력형 옵션
          // 비조합형 필수 옵션 조합 아이디
          combinationId1: item.combinationId1,
          combinationId2: item.combinationId2,
          combinationId3: item.combinationId3,
        });
      });

      // 필수 항목 체크
      // require 1개 이상 체크
      let requireCheck = false;
      requiredOptionSetting.value.forEach((item, index) => {
        if (
          productOptionList.filter((option) => option.require === true).length >
          0
        ) {
          requireCheck = true;
        }
      });

      if (requireCheck === false) {
        alert("필수 옵션을 하나 이상 선택해 주세요.");
        return false;
      }

      console.log(productOptionList);
      if (productOptionList.length > 0) {
        param.productOptionList = productOptionList;
      } else {
        alert("옵션을 선택해 주세요.");
        return false;
      }
    }
  }

  console.log(param);
  console.log(` addCart END ------------------------------- `);
  // return false;

  // 유효성 검사

  try {
    await axios.post("/new_api/customer/cart/v2/edit", param).then((res) => {
      if (res.status === 200) {
        console.log(res.data);
        if (res.data.code === "200") {
          alert("장바구니에 담겼습니다.");
          router.push({ name: "cart" }); // 장바구니 이동 여부 묻도록 변경할 것
        } else if (res.data.code === "031") {
          // 재고 부족
          console.log(res.data.pathNameList);
          const pathNameList = res.data.pathNameList.join(", ");
          console.log(pathNameList);
          const alert_msg = `재고가 부족한 옵션이 포함 되어 있습니다.\n\n${res.data.optionName} - ${pathNameList}`;
          alert(alert_msg);
          return false;
        } else if (res.data.code === "032") {
          // TODO: 상품 불러올 때 판매중지 여부 체크 필요
          alert("판매중지된 상품이므로 구매하실 수 없습니다.");
          window.location.reload();
        }
      } else {
        console.log(res);
      }
    });
  } catch (e) {
    console.log(e);
  }

  /*
  editCart(
    contentDetail.value.itemId,
    quantity.value,
    true,
    'CREATE',
    selectedLicense.value
  ).then((res) => {
    console.log(res)
    if (res.data.code === '200') {
      alert('장바구니에 담겼습니다.');
      router.push({ name: 'cart' }); // 장바구니 이동 여부 묻도록 변경할 것
    } else if (res.data.code === '032') {
      alert('판매중지된 상품이므로 구매하실 수 없습니다.');
      window.location.reload();
    }
  });
   */
};

const deleteCart = (item) => {
  console.log("deleteCart");
  selectedOptionList.value =
    selectedOptionList.value.slice(0, item) +
    selectedOptionList.value.slice(item + 1);
};

const refreshPage = (related) => {
  window.location.href = "/mall/view/" + related;
};

// 팝오버 관련 메소드들
const showPopover = (type) => {
  clearTimeout(popoverTimer.value);
  activePopover.value = type;
};

const hidePopover = (type) => {
  popoverTimer.value = setTimeout(() => {
    if (activePopover.value === type) {
      activePopover.value = null;
    }
  }, 300);
};

const togglePopover = (type) => {
  if (activePopover.value === type) {
    activePopover.value = null;
  } else {
    activePopover.value = type;
  }
};

// 탭 전환 함수
const changeTab = (tabName) => {
  activeTab.value = tabName;
};
</script>

<style scoped>
.selectClass {
  @apply border border-neutral-800 p-2 col-span-4 w-full;
}
.countBox {
  @apply py-2 px-3 inline-block bg-white rounded-lg dark:bg-slate-900 dark:border-gray-700;
}

/* 팝오버 스타일 */
.popover-item {
  @apply w-full bg-blue-50 px-2 py-1 rounded-full cursor-pointer whitespace-pre relative;
}

.popover-content {
  @apply absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-slate-800 text-white text-sm rounded-lg z-10 whitespace-nowrap;
}

.popover-arrow {
  @apply absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-slate-800;
}

/* 탭 관련 스타일 */
.tab-container {
  @apply w-full;
}

.tab-content-wrapper {
  @apply bg-white;
}

.tab-content {
  @apply w-full;
}

/* 탭 전환 애니메이션 추가 스타일 */
.tab-slide-enter-active,
.tab-slide-leave-active {
  @apply transition-all duration-300;
}

.tab-slide-enter-from {
  @apply transform translate-x-4 opacity-0;
}

.tab-slide-leave-to {
  @apply transform -translate-x-4 opacity-0;
}
</style>
